import { MapEntity } from "../../../../lib/gamemap/MapEntity";
import * as leaflet from "leaflet";
import { ShortcutViewLayer } from "../../shortcut_editing/ShortcutView";
import { FloorLevels, ZoomLevels } from "../../../../lib/gamemap/ZoomLevels";
import { floor_t } from "../../../../lib/runescape/coordinates";
import { CursorType } from "../../../../lib/runescape/CursorType";
import { C } from "../../../../lib/ui/constructors";
import Properties from "../../widgets/Properties";
import { TileArea } from "../../../../lib/runescape/coordinates/TileArea";
var COLORS = ShortcutViewLayer.COLORS;
var entity = C.entity;
import { LeafletUtils } from "../../../../lib/gamemap/LeafletUtils";
export class RemoteEntityTransportTarget extends MapEntity {
    constructor(transport, action, movement) {
        super();
        this.transport = transport;
        this.action = action;
        this.movement = movement;
        this.zoom_sensitivity_layers = MapEntity.default_zoom_scale_layers;
        this.floor_sensitivity_layers = undefined;
        if (!movement.fixed_target)
            debugger;
        this.zoom_sensitivity_layers = new ZoomLevels([
            { min: -100, value: { scale: 0.5 } },
            { min: 1.5, value: { scale: 1 } },
        ]);
        this.floor_sensitivity_layers = new FloorLevels([
            { floors: [TileArea.normalize(movement.fixed_target.target).origin.level], value: { correct_level: true } },
            { floors: floor_t.all, hidden_here: true, value: { correct_level: false } },
        ]);
        this.setTooltip(() => {
            let props = new Properties();
            props.header(c().append(`Target of `, entity(this.transport.entity)));
            return props;
        });
    }
    bounds() {
        return TileArea.toRect(TileArea.normalize(this.movement.fixed_target.target));
    }
    async render_implementation(props) {
        const scale = (props.highlight ? 1.5 : (this.zoom_sensitivity_layers.get(props.zoom_group_index).value.scale));
        const circle = leaflet.circle(LeafletUtils.latLongFromVector2(TileArea.activate(TileArea.normalize(this.movement.fixed_target.target)).center()), {
            color: COLORS.target_area,
            weight: 2,
            radius: scale * 0.4,
            fillOpacity: 0.1,
        }).addTo(this);
        return circle.getElement();
    }
    async contextMenu(event) {
        event.addForEntity({
            type: "basic",
            text: "Jump to Origin",
            handler: () => {
                this.parent?.getMap()?.fitView(this.transport.clickable_area);
            }
        });
        return {
            type: "submenu",
            icon: CursorType.meta(this.action.cursor ?? "generic").icon_url,
            text: () => c().append("Target of ", entity(this.transport.entity)),
            children: []
        };
    }
}
